import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import s from './Popup.css';
import { getOwnership, saveOwnership, setSearchQuery } from '../../actions/device';
import EditOwnershipPopupView from './EditOwnershipPopupView';

class EditOwnershipPopup extends React.Component {
  componentWillMount() {
    this.props.getOwnership(
      this.props.serial,
      this.props.userType, 
      {}
    );
  }

  onSubmit = data => {
    const user = data.users;
    this.props.saveOwnership(this.props.serial, {
      user,
      role: this.props.userType,
    });
    this.props.onClose();
  };

  componentWillUpdate(newProps) {
    const searchQueryChanged =
      newProps.ownershipData.get('searchQuery') !==
      this.props.ownershipData.get('searchQuery');
    if (searchQueryChanged) {
      const search = newProps.ownershipData.get('searchQuery');
      this.props.getOwnership(
        this.props.serial,
        this.props.userType, 
        {search,}
      );
    }
  }

  render() {
    return (
      <EditOwnershipPopupView
        ownershipData={this.props.ownershipData}
        saveOwnership={this.props.saveOwnership}
        setSearchQuery={this.props.setSearchQuery}
        onSubmit={this.onSubmit}
        onClose={this.props.onClose}
        devicetype={this.props.devicetype}
        serial={this.props.serial}
      />
    );
  }
}

EditOwnershipPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  getOwnership: PropTypes.func.isRequired,
  saveOwnership: PropTypes.func.isRequired,
  ownershipData: PropTypes.object.isRequired,  // eslint-disable-line react/forbid-prop-types
  serial: PropTypes.string.isRequired,
  devicetype: PropTypes.string,
  userType: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
};

const mapState = state => ({
  ownershipData: state.ownershipData,
});

EditOwnershipPopup.defaultProps = {
  devicetype: '',
};

const mapDispatch = dispatch => {
  return {
    getOwnership: (serial, userType, params) => dispatch(getOwnership(serial, userType, params)),
    saveOwnership: (serial, data) => dispatch(saveOwnership(serial, data)),
    setSearchQuery: searchQuery => dispatch(setSearchQuery(searchQuery)),
  };
};

export default compose(connect(mapState, mapDispatch), withStyles(s))(
  EditOwnershipPopup,
);



// WEBPACK FOOTER //
// ./src/components/Popup/EditOwnershipPopup.js